<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64" elevation="1">
        <v-toolbar flat color="white">
          <v-btn fab text small color="grey darken-2" data-cy="prev" @click="prev">
            <v-icon small>chevron_left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" data-cy="next" @click="next">
            <v-icon small>chevron_right</v-icon>
          </v-btn>
          <v-toolbar-title class="ml-4">{{ title }}</v-toolbar-title>
          <v-spacer/>
          <v-btn class="mr-4" color="success" @click="setToday">
            {{ $t('move.calendar.today') }}
          </v-btn>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn
                color="success"
                v-on="on"
                data-cy="change-calendar-type"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>{{$t('move.calendar.day')}}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>{{$t('move.calendar.week')}}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>{{$t('move.calendar.month')}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="calc(100vh - 176px)">
        <v-calendar
          ref="calendar"
          v-model="focus"
          class="device-usage-calendar"
          :class="{'v-calendar-weekly' : (type === 'week')}"
          color="primary"
          :events="devicesUsageInfo"
          :event-color="getMoveColor"
          :event-height="30"
          :now="today"
          :type="type"
          event-more
          :interval-count="0"
          @click:date="viewDay"
          @click:more="viewDay"
          @change="updateRange"
          data-cy="calendar"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
  import * as actions from '@/store/actions.type';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'DevicesCalendar',
    data: () => ({
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
      },
      start: null,
      end: null,
      firstDay: null,
      lastDay: null,
      today: null,
    }),
    computed: {
      ...mapGetters([
        'devicesUsage',
      ]),
      title() {
        const {start, end} = this;
        if (!start || !end) {
          return '';
        }

        const startMonth = this.monthFormatter(start);
        const endMonth = this.monthFormatter(end);
        const suffixMonth = startMonth === endMonth ? '' : endMonth;

        const startYear = start.year;
        const endYear = end.year;
        const suffixYear = startYear === endYear ? '' : endYear;

        const startDay = start.day + this.nth(start.day);
        const endDay = end.day + this.nth(end.day);

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`;
          case 'week':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`;
        }

        return '';
      },
      monthFormatter() {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        });
      },
      devicesUsageInfo() {
        let usageInfo = [];

        this.devicesUsage.forEach(device => {
          usageInfo.push({
            name: `${device.devicesInUse} ${device.devicesInUse === 1 ? this.$t('device.deviceSingle') : this.$t('device.deviceMultiple')}`,
            start: this.formatDate(new Date(device.date)),
            color: 'blue lighten-1'
          });
        });

        return usageInfo;
      },
      usageParams() {
        return {
          startDate: this.firstDay,
          endDate: this.lastDay,
        }
      },
    },
    methods: {
      ...mapActions({
        fetchDevicesUsageAction: actions.FETCH_DEVICES_USAGE,
      }),
      viewDay({date}) {
        this.focus = date;
        this.type = 'day';
      },
      getMoveColor(event) {
        return event.color;
      },
      setToday() {
        this.focus = this.today;
      },
      prev() {
        this.$refs.calendar.prev();
      },
      next() {
        this.$refs.calendar.next();
      },
      updateRange({start, end}) {
        this.start = start;
        this.end = end;

        const startDate = new Date(start.date);
        const endDate = new Date(end.date);

        start.weekday === 0
          ? this.firstDay = new Date(start.date)
          : this.firstDay = new Date(startDate.getTime() - (start.weekday * 24 * 60 * 60 * 1000));

        end.weekday === 6
          ? this.lastDay = new Date(end.date)
          : this.lastDay = new Date(endDate.getTime() + ((6 - end.weekday) * 24 * 60 * 60 * 1000));

        this.fetchDevicesUsageAction(this.usageParams);
      },
      nth(d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      },
    },
  };
</script>

<style scoped>

</style>